import { createContext, useContext, useState, useMemo, useCallback } from "react";

export const translations = {
    es: {
        nav: {
            services: "Servicios",
            experience: "Experiencia",
            ebook: "Ebook",
            contact: "Contrata ya",
            location: "Ubicación",
            hireMe: "Contratar",
        },
        hero: {
            eyebrow: "Monterrey · Nuevo León · México",
            name: "Gilberto Veliz",
            handle: "@gilbertoevelize",
            role: "Desarrollador Web & Arquitecto de Soluciones Digitales",
            tagline:
                "Diseño landing pages, websites accesibles, cobranza por internet y asistentes virtuales con inteligencia artificial.",
            cta: "Iniciar proyecto",
            ctaSecondary: "Ver servicios",
            yearsBadge: "+20 años de experiencia",
        },
        experience: {
            kicker: "Trayectoria",
            heading: "Dos décadas construyendo productos digitales que funcionan.",
            copy:
                "Más de 20 años acompañando a empresas, emprendedores y corporativos en su transformación digital. Desde pequeñas landing pages hasta plataformas completas con cobranza en línea e inteligencia artificial integrada. Código limpio, diseño claro, resultados medibles.",
            stats: [
                { n: "20+", l: "años de experiencia" },
                { n: "180+", l: "proyectos entregados" },
                { n: "100%", l: "enfoque en accesibilidad" },
                { n: "IA", l: "integrada a medida" },
            ],
        },
        services: {
            kicker: "Servicios",
            heading: "Soluciones digitales, hechas a la medida.",
            subheading:
                "Cada proyecto parte de tu negocio, no de una plantilla. Desarrollo moderno, accesible y optimizado para buscadores.",
            items: [
                {
                    title: "Landing Pages",
                    copy: "Páginas de alta conversión. Diseño editorial, copy persuasivo y SEO técnico desde la base.",
                    image:
                        "https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Desarrollo de Websites",
                    copy: "Sitios corporativos y de marca, accesibles (WCAG), rápidos y optimizados para Google.",
                    image:
                        "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Cobranza por Internet",
                    copy: "Integración de pagos en línea: Stripe, PayPal, Mercado Pago, OXXO Pay y suscripciones.",
                    image:
                        "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Asistentes Virtuales con IA",
                    copy: "Chatbots y agentes con IA que atienden clientes 24/7, conectados a tu CRM y canales.",
                    image:
                        "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Automatización & APIs",
                    copy: "Integraciones entre sistemas, webhooks, automatización de flujos y dashboards a medida.",
                    image:
                        "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Consultoría Digital",
                    copy: "Estrategia técnica, auditorías de SEO, performance y accesibilidad para tu operación.",
                    image:
                        "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=900&q=70",
                },
            ],
        },
        ebook: {
            kicker: "Ebook",
            heading: "Arquitecto Digital — el libro.",
            subheading:
                "Mi guía completa para diseñar, construir y escalar productos digitales rentables. Más de 20 años de experiencia condensados en un libro práctico.",
            bullets: [
                "Estrategia digital paso a paso",
                "Cómo elegir tu stack tecnológico",
                "Cobranza online e inteligencia artificial aplicada",
                "Plantillas y checklists descargables",
            ],
            cta: "Adquiere el eBook · Conviértete en Arquitecto Digital",
            ctaShort: "Adquiere el Ebook",
            ctaSub: "Pago seguro vía Hotmart",
            badge: "PDF · Acceso inmediato",
        },
        contact: {
            kicker: "Contrata ya",
            heading: "Conversemos sobre tu proyecto.",
            copy: "Respondo personalmente en menos de 24 horas hábiles.",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            phoneLabel: "Teléfono",
            form: {
                name: "Nombre completo",
                email: "Correo electrónico",
                phone: "Teléfono (opcional)",
                subject: "Asunto",
                message: "Cuéntame sobre tu proyecto",
                consent:
                    "He leído y acepto el Aviso de Privacidad y el tratamiento de mis datos.",
                submit: "Enviar mensaje",
                sending: "Enviando…",
                success:
                    "Mensaje enviado. Te contacto muy pronto.",
                error: "No se pudo enviar. Intenta de nuevo o escríbeme por WhatsApp.",
                consentRequired:
                    "Debes aceptar el Aviso de Privacidad para continuar.",
            },
        },
        location: {
            kicker: "Ubicaciones",
            heading: "Basado entre México y Texas, trabajando con el mundo.",
            city: "Monterrey, Nuevo León — México",
            city2: "The Woodlands, Texas — USA · ZIP 77386",
            copy: "Atención remota y presencial en el área metropolitana de Monterrey y en The Woodlands, Texas.",
            primaryLabel: "Oficina principal",
            secondaryLabel: "Oficina satélite",
        },
        privacy: {
            kicker: "Aviso de Privacidad",
            heading: "Tu información está protegida.",
            paragraphs: [
                "Gilberto Veliz, responsable del tratamiento de tus datos personales, informa que la información que proporciones a través de este sitio (nombre, correo, teléfono y mensaje) será utilizada exclusivamente para responder tu solicitud de contacto y enviarte propuestas comerciales relacionadas.",
                "No compartimos, vendemos ni cedemos tus datos a terceros sin tu consentimiento expreso. Los datos se almacenan en servidores protegidos y se conservan únicamente por el tiempo necesario para cumplir con la finalidad informada.",
                "En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) de México, puedes ejercer tus derechos ARCO (Acceso, Rectificación, Cancelación y Oposición) en cualquier momento escribiendo a nuestro WhatsApp o correo.",
                "Este sitio utiliza cookies técnicas necesarias para su funcionamiento. Al usarlo, aceptas el uso de las mismas.",
            ],
            rights:
                "Derechos ARCO · LFPDPPP · Monterrey, N.L., México",
        },
        footer: {
            tagline:
                "Desarrollo web ejecutivo · Landing pages · IA aplicada · Cobranza en línea",
            rights: "Todos los derechos reservados.",
            made: "Sitio diseñado y desarrollado por Gilberto Veliz.",
        },
    },
    en: {
        nav: {
            services: "Services",
            experience: "Experience",
            ebook: "Ebook",
            contact: "Hire now",
            location: "Location",
            hireMe: "Hire me",
        },
        hero: {
            eyebrow: "Monterrey · Nuevo León · Mexico",
            name: "Gilberto Veliz",
            handle: "@gilbertoevelize",
            role: "Web Developer & Digital Solutions Architect",
            tagline:
                "I design landing pages, accessible websites, online payment integrations and AI-powered virtual assistants.",
            cta: "Start a project",
            ctaSecondary: "View services",
            yearsBadge: "20+ years of experience",
        },
        experience: {
            kicker: "Track record",
            heading: "Two decades building digital products that work.",
            copy:
                "Over 20 years helping companies, founders and enterprises go digital. From small landing pages to full-scale platforms with online payments and embedded artificial intelligence. Clean code, clear design, measurable results.",
            stats: [
                { n: "20+", l: "years of experience" },
                { n: "180+", l: "projects delivered" },
                { n: "100%", l: "accessibility focus" },
                { n: "AI", l: "custom integrated" },
            ],
        },
        services: {
            kicker: "Services",
            heading: "Tailor-made digital solutions.",
            subheading:
                "Every project starts with your business — not a template. Modern, accessible, SEO-first development.",
            items: [
                {
                    title: "Landing Pages",
                    copy: "High-converting pages. Editorial design, persuasive copy and technical SEO from the ground up.",
                    image:
                        "https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Website Development",
                    copy: "Corporate and brand websites, WCAG-accessible, fast and Google-optimized.",
                    image:
                        "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Online Payments",
                    copy: "Payment integrations: Stripe, PayPal, Mercado Pago, OXXO Pay and subscriptions.",
                    image:
                        "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "AI Virtual Assistants",
                    copy: "Chatbots and AI agents serving your customers 24/7, connected to your CRM and channels.",
                    image:
                        "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Automation & APIs",
                    copy: "System integrations, webhooks, workflow automation and custom dashboards.",
                    image:
                        "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=900&q=70",
                },
                {
                    title: "Digital Consulting",
                    copy: "Technical strategy, SEO, performance and accessibility audits for your operation.",
                    image:
                        "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=900&q=70",
                },
            ],
        },
        ebook: {
            kicker: "Ebook",
            heading: "Digital Architect — the book.",
            subheading:
                "My complete guide to designing, building and scaling profitable digital products. Over 20 years of experience distilled into a practical book.",
            bullets: [
                "Step-by-step digital strategy",
                "How to choose your tech stack",
                "Online payments and applied AI",
                "Downloadable templates and checklists",
            ],
            cta: "Get the eBook · Become a Digital Architect",
            ctaShort: "Get the Ebook",
            ctaSub: "Secure checkout via Hotmart",
            badge: "PDF · Instant access",
        },
        contact: {
            kicker: "Hire now",
            heading: "Let's talk about your project.",
            copy: "I personally reply within 24 business hours.",
            whatsapp: "WhatsApp",
            facebook: "Facebook",
            linkedin: "LinkedIn",
            phoneLabel: "Phone",
            form: {
                name: "Full name",
                email: "Email address",
                phone: "Phone (optional)",
                subject: "Subject",
                message: "Tell me about your project",
                consent:
                    "I have read and accept the Privacy Notice and the processing of my data.",
                submit: "Send message",
                sending: "Sending…",
                success: "Message sent. I'll be in touch shortly.",
                error: "Could not send. Please try again or message me on WhatsApp.",
                consentRequired:
                    "You must accept the Privacy Notice to continue.",
            },
        },
        location: {
            kicker: "Locations",
            heading: "Based between Mexico and Texas, working worldwide.",
            city: "Monterrey, Nuevo León — Mexico",
            city2: "The Woodlands, Texas — USA · ZIP 77386",
            copy: "Remote and on-site service across the Monterrey metropolitan area and The Woodlands, Texas.",
            primaryLabel: "Main office",
            secondaryLabel: "Satellite office",
        },
        privacy: {
            kicker: "Privacy Notice",
            heading: "Your data is protected.",
            paragraphs: [
                "Gilberto Veliz, responsible for handling your personal data, informs you that the information you submit through this site (name, email, phone and message) will be used exclusively to reply to your contact request and send related proposals.",
                "We do not share, sell or transfer your data to third parties without your express consent. Data is stored on secured servers and kept only for the time strictly necessary to fulfill the stated purpose.",
                "In compliance with the Mexican Federal Law on the Protection of Personal Data Held by Private Parties (LFPDPPP), you may exercise your ARCO rights (Access, Rectification, Cancellation, Opposition) at any time via WhatsApp or email.",
                "This site uses essential technical cookies required for its operation. By using it, you accept their use.",
            ],
            rights: "ARCO Rights · LFPDPPP · Monterrey, N.L., Mexico",
        },
        footer: {
            tagline:
                "Executive web development · Landing pages · Applied AI · Online payments",
            rights: "All rights reserved.",
            made: "Site designed and developed by Gilberto Veliz.",
        },
    },
};

const LangContext = createContext({
    lang: "es",
    setLang: () => {},
    t: translations.es,
});

export const LangProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "es";
        return localStorage.getItem("gv_lang") || "es";
    });

    const setLang = useCallback((next) => {
        setLangState(next);
        try {
            localStorage.setItem("gv_lang", next);
            document.documentElement.lang = next;
        } catch (e) {
            /* ignore */
        }
    }, []);

    const value = useMemo(
        () => ({ lang, setLang, t: translations[lang] }),
        [lang, setLang],
    );

    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
